<header
  class="mobile-header"
  (click)="navigateToAppStoreLink()">
  <div class="description">
    <img src="../assets/images/farm-portal-mobile-icon.png" />
    <div class="description-title">
      <h3 class="app-name">{{ 'APPLICATION.MOBILE_INFO_HEADER.appName' | translate }}</h3>
      <p>{{ 'APPLICATION.MOBILE_INFO_HEADER.appDescription' | translate }}</p>
    </div>
  </div>

  <div class="mobile-header_buttons">
    <span class="mobile-header_buttons-button"><i class="ph ph-download-simple"></i></span>

    <span
      class="mobile-header_buttons-button"
      (click)="onClose($event)"
      ><i class="ph ph-x"></i
    ></span>
  </div>
</header>
